export default __webpack_public_path__ + "static/media/MT1_activations_XY.a93e3160.png";